export default "__VITE_ASSET__7be4602c__"